<template>
  <prod-page>
    <el-row style="width: 64%;margin-left: 18%;margin-top: 40px;display: flex;">
      <el-col style="width: 26%;border-right: 1px solid #5e5e5e;">
        <el-row v-for="(data, i) in dataList" :key="i" :class="i === selMenu ? 'menu-class-hover' : 'menu-class'" @click.native="clickMenu(i)">
          {{data.name}}
        </el-row>
      </el-col>
      <el-col v-if="!isDetail" style="width: 67%;margin-left: 7%;text-align: left;">
        <el-row v-for="(item, i) in data" :key="i" v-if="i % 2 === 0" style="height: 160px;margin-top: 40px;">
          <el-col style="width: 50%;height: 100%;display: flex;">
            <el-image :src="data[i].image" class="img-class" fit="scale-down" @click.native="clickHardware(data[i])"></el-image>
            <el-col style="width: 30%;height: 100%;">
              <el-row class="model-class" @click.native="clickHardware(data[i])">{{data[i].model}}</el-row>
              <el-row class="text-class">{{data[i].name}}</el-row>
            </el-col>
          </el-col>
          <el-col v-if="data.length > i + 1" style="width: 50%;height: 100%;display: flex;">
            <el-image :src="data[i + 1].image" class="img-class" fit="scale-down" @click.native="clickHardware(data[i + 1])"></el-image>
            <el-col style="width: 30%;height: 100%;">
              <el-row class="model-class" @click.native="clickHardware(data[i + 1])">{{data[i + 1].model}}</el-row>
              <el-row class="text-class">{{data[i + 1].name}}</el-row>
            </el-col>
          </el-col>
        </el-row>
      </el-col>
      <el-col v-else style="width: 67%;margin-left: 7%;text-align: left;">
        <el-row style="height: 160px;margin-top: 40px;">
          <el-col style="width: 50%;height: 100%;display: flex;">
            <el-image :src="detail.image" class="img-class" fit="scale-down"></el-image>
            <el-col style="width: 30%;height: 100%;">
              <el-row class="model-class-ext">{{detail.model}}</el-row>
              <el-row class="text-class">{{detail.name}}</el-row>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="text-align: left;white-space: pre-wrap;line-height: 40px;font-size: 16px;margin-top: 60px;">
          {{detail.detail}}
        </el-row>
      </el-col>
    </el-row>
  </prod-page>
</template>

<script>
import ProdPage from './ProdPage'
export default {
  name: 'Hardware',
  components: {ProdPage},
  props: {
    'selId': {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isDetail: false,
      dataList: [
        {
          id: '321',
          param: 'meter',
          name: '仪表类',
          data: [
            {
              id: '3211',
              model: 'YK-8100',
              name: '智能能效采集终端',
              image: require('../../assets/img/hardware/yk8100.png'),
              detail: '全电量监测：三相电压、三相电流、剩余电流、功率、电量、功率因素、频率\n' + '        电能质量监测：2-31次谐波、奇次/偶次/总谐波畸变率、不平衡度\n' + '        支持开口CT或穿刺CT，免停电安装\n' + '        支持4路温度测量、2路开关量采集、2路开关量输出\n' + '        多种通信方式：RS485（默认）、微功率无线/4G/GPRS/LoRa（可选）'
            },
            {
              id: '3212',
              model: 'YK-8210',
              name: '三相智能电表',
              image: require('../../assets/img/hardware/yk8210.png'),
              detail: '全电量监测、0.5S级高精度电能计量\n' + '        额定电流1/5/10A可选，测量范围6/60/80A \n' + '        分时计费、需量、谐波、定值越限\n' + '        多路输入输出\n' + '         多种通信方式：RS485（默认）、红外（默认）、微功率无线/4G/GPRS/LoRa（可选）'
            },
            {
              id: '3213',
              model: 'YK-8220',
              name: '单相智能电表',
              image: require('../../assets/img/hardware/yk8220.png'),
              detail: '全电量监测、1级高精度电能计量\n' + '        额定电流5A，最大测量范围60A\n' + '        分时计费、需量、谐波、定值越限\n' + '        多路输入输出\n' + '        多种通信方式：RS485（默认）、红外（默认）、微功率无线/4G/GPRS/LoRa（可选）'
            },
            {
              id: '3214',
              model: 'YK-8300',
              name: '直流电表',
              image: require('../../assets/img/hardware/yk8300.png'),
              detail: '1级高精度电能计量\n' + '        参比电压Un：100V、500V、700V、1000V\n' + '        直流分流器输出电压： 75mV\n' + '        多种通信方式：RS485（默认）、红外（默认）、微功率无线/4G/GPRS/LoRa（可选）'
            },
            {
              id: '3215',
              model: 'YK-8400',
              name: '负荷识别终端',
              image: require('../../assets/img/hardware/yk8400.png'),
              detail: '电压、电流、功率、功率因素、频率监测\n' + '        电压电流测量精度±0.5%、电能计量精度±1%\n' + '        单一电器识别准确度＞90%，混合电器识别准确度＞80%\n' + '        单一电器计量准确度＞80%，混合电器计量准确度＞70%\n' + '        多种通信方式：RS485（默认）、WIFI/4G/GPRS/LoRa/ZigBee/蓝牙（可选）'
            },
            {
              id: '3216',
              model: 'YK-8500',
              name: '智能微断',
              image: require('../../assets/img/hardware/yk8500.png'),
              detail: '电压、电流、漏电流实时监测、电量计量\n' + '        支持本地漏电自检、手机操作漏电自检、漏电自动自检\n' + '        支持短路保护、漏电保护、过流保护、过压保护、过温保护\n' + '        支持欠压报警、过压报警、打火断电报警\n' + '        额定电压220V、额定电流16/20/32/40/63/80/100A可选\n' + '        漏电30mA，≤0.1s断路保护\n' + '        支持本地手动/电机控制、远程手机控制\n' + '        机械寿命≥60000次\n' + '        多种通信方式：RS485（默认）、WIFI/4G/\n' + '        GPRS/LoRa/ZigBee/蓝牙（可选）'
            },
            {
              id: '3217',
              model: 'YK-8600',
              name: '物联网智能断路器',
              image: require('../../assets/img/hardware/yk8600.png'),
              detail: '电压、电流、剩余电流实时监测、电量计量\n' + '        采用测量与保护CT，动作可靠、精度高\n' + '        剩余电流保护，剩余电流档位可在线整定，具有重合闸功能\n' + '        支持短路保护、漏电保护、过流保护、过压保护、欠压保护、缺相保护、过温保护\n' + '        长延时、短延时和瞬时三段保护，采用电子式脱扣，与电源电压无关\n' + '        具有高分断能力，保证线路短路保护的可靠性；\n' + '        线路剩余电流、三相电源电压、负荷电流、功率、电量实时显示；\n' + '        保护功能及参数可在线设置修改；\n' + '        跳闸类型（剩余电流、闭锁、过载、欠压、过压、缺相）识别、显示，并可存储、查询、删除；\n' + '        额定电压380V、壳架电流125/250/400/630/800A可选\n' + '        支持本地/远程分合闸\n' + '        通信方式：RS485（默认）、4G/GPRS/LoRa/ZigBee/蓝牙/微功率无线（可选）\n' + '        定位对时功能可选：GPS/BD双模'
            }
          ]
        },
        {
          id: '322',
          param: 'sensor',
          name: '传感类',
          data: [
            {
              id: '3221',
              model: 'YK-9100',
              name: '开口式互感器',
              image: require('../../assets/img/hardware/yk9100.png'),
              detail: '开口铁芯结构设计，免停电安装\n' + '        0.5级测量精度、相位线性误差≤30′\n' + '        初级线圈5—400Aac可选，次级电压/电流输出可选、孔径5—35mm可选\n' + '        50—1KHz工作频率、-25℃—50℃工作温度'
            },
            {
              id: '3222',
              model: 'YK-9200',
              name: '系列无线测温装置',
              image: require('../../assets/img/hardware/yk9200.png'),
              detail: '汇集单元最大支持45个无线传感单元\n' + '        传感单元支持LoRa/ZigBee/微功率无线可选\n' + '        -25℃~120℃温度测量范围、±2℃测量精度、±0.1℃分辨率\n' + '        支持有源/无源模式\n' + '        汇集单元支持4路无源节点输出、2路开关量采集、1路温湿度传感器接入\n' + '        汇集单元通信方式：RS485（默认）、4G/GPRS/LoRa/微功率无线（可选）'
            },
            {
              id: '3223',
              model: 'YK-9300',
              name: '微环境监测装置',
              image: require('../../assets/img/hardware/yk9300.png'),
              detail: '本产品用于局部空间的环境参数精细化测量和调控\n' + '        支持采集温湿度、水浸、门开关状态、接点状态\n' + '        就地数据分析、对环境进行除湿、排水等控制 \n' + '        终端与传感器之间基于433M无线通信\n' + '        监测主机通信方式：RS485（默认）、GPRS/LoRa（可选）'
            },
            {
              id: '3224',
              model: 'YK-9400',
              name: '变压器铁芯接地在线监测装置',
              image: require('../../assets/img/hardware/yk9400.png'),
              detail: '实时监测铁心接地电流值\n' + '        接地电流报警值可设置，当接地电流值超过设定值后报警，故障消失后停止报警\n' + '        1mA 10A测量范围，1mA的高分辨率\n' + '        IP68防护等级\n' + '        -20℃~70℃工作温度\n' + '        通信方式：RS485（默认）、4G/GPRS/LoRa/ZigBee/微功率无线（可选）'
            },
            {
              id: '3225',
              model: 'YK-9600',
              name: '电气火灾探测器',
              image: require('../../assets/img/hardware/yk9600.png'),
              detail: '1路剩余电流监测，50-1000mA可调，动作延迟时间0.1s—60s可调\n' + '        4路温度测量，温度报警范围40—140℃可调\n' + '        消防报警功能，声光报警\n' + '        1路继电器输出\n' + '        多种通信方式：CAN（默认）、RS485（可选）'
            }
          ]
        },
        {
          id: '323',
          param: 'smart',
          name: '智能类',
          data: [
            {
              id: '3231',
              model: 'YK-6110',
              name: '通讯管理机',
              image: require('../../assets/img/hardware/yk6110.png'),
              detail: '工业级ARM9处理器、Linux系统\n' + '        支持1路10/100M自适应网口、支持2路RS485接口、1路4G/GPRS接口\n' + '        下行支持ModbusRTU、ModbusTCP、IEC60870-5-101、DL/T645、私有协议\n' + '        上行支持ModbusRTU、ModbusTCP、IEC60870-5-101、IEC60870-5-104、MQTT、私有协议'
            },
            {
              id: '3232',
              model: 'YK-6120',
              name: '通讯管理机',
              image: require('../../assets/img/hardware/yk6120.png'),
              detail: '工业级Cortex-A8/国产工业级四核Cortex-A7处理器、Linux系统\n' + '        支持2路10/100M自适应网口、支持2/4/6/8路RS485接口\n' + '        支持1路4G/GPRS接口、支持1路CAN接口\n' + '        可选配内置GPS/BD定位对时模块\n' + '        下行支持ModbusRTU、ModbusTCP、IEC60870-5-101、IEC60870-5-104、DL/T645、私有协议\n' + '        上行支持ModbusRTU、ModbusTCP、IEC60870-5-101、IEC60870-5-104、MQTT、私有协议'
            },
            {
              id: '3233',
              model: 'YK-6210',
              name: '总线通信网关',
              image: require('../../assets/img/hardware/yk6210.png'),
              detail: '支持1路10/100M自适应网口\n' + '        支持1路RS485接口、最大支持128个智能总线控制器\n' + '        无线通信WIFI/GPRS/LoRa/ZigBee/蓝牙/微功率无线（可选）\n' + '        支持1路程序升级更新USB接口'
            },
            {
              id: '3234',
              model: 'YK-6220',
              name: '智能总线控制器',
              image: require('../../assets/img/hardware/yk6220.png'),
              detail: '支持1路YK-BUS总线、最大支持64个YK-BUS总线设备\n' + '        支持1路RS485接口接入总线通信网关\n' + '        具有配置数据备份模块'
            },
            {
              id: '3235',
              model: 'YK-6230',
              name: '智能继电器模块',
              image: require('../../assets/img/hardware/yk6230.png'),
              detail: 'YK-BUS总线设备\n' + '        支持4路继电器输出、40A阻性/16A感性/4A荧光灯/16A白炽灯负载\n' + '        大于10万次开关寿命'
            },
            {
              id: '3236',
              model: 'YK-6300',
              name: '无线自组网模块',
              image: require('../../assets/img/hardware/yk6300.png'),
              detail: '433MHz/470MHz/2.4GHz微功率发射，可调节，功耗低、抗干扰能力强\n' + '        半双工通讯，空中收/发自动转换\n' + '        内嵌 MESH 分布式自组网协议，每次通讯都有多重握手确认，确保数据的稳定\n' + '        通信频率任意设置，32个辅助信道，自动跳频，有效避免干扰\n' + '        通讯协议转换及射频收发切换自动完成，用户无须干预，简单易用\n' + '        通讯距离500m-2km'
            }
          ]
        },
        // {
        //   id: '324',
        //   param: 'secure',
        //   name: '安防类',
        //   data: [
        //     {
        //       id: '3241',
        //       model: 'YK-4110',
        //       name: '红外半球网络高清摄像机',
        //       image: require('../../assets/img/hardware/yk4110.png'),
        //       detail: '最高分辨率可达2M(1920×1080 @ 30fps)\n' + '        支持低码率、低延时\n' + '        H.265高效压缩，节省带宽和存储空间\n' + '        支持多行OSD,OSD颜色、大小自选\n' + '        支持3D数字降噪, 支持DWDR\n' + '        支持自动电子快门功能,适应不同监控环境\n' + '        支持走廊模式，增加纵向狭长环境下监控区域\n' + '        支持多种智能报警\n' + '        支持Smart IR，防止夜间红外过曝\n' + '        高效红外灯,使用寿命长,照射距离20-30米\n' + '        ICR红外滤片式自动切换,实现真正的日夜监控\n' + '        支持PoE供电功能（选配）\n' + '        支持GB28181接入,支持Onvif接入\n' + '        支持Email、NTP服务\n' + '        支持HTTPS加密传输'
        //     },
        //     {
        //       id: '3242',
        //       model: 'YK-4120',
        //       name: '红外枪型网络高清摄像机',
        //       image: require('../../assets/img/hardware/yk4120.png'),
        //       detail: '最高分辨率可达2M(1920×1080 @ 30fps)\n' + '        支持低码率、低延时\n' + '        H.265高效压缩，节省带宽和存储空间\n' + '        支持多行OSD,OSD颜色、大小自选\n' + '        支持3D数字降噪, 支持DWDR\n' + '        支持自动电子快门功能,适应不同监控环境\n' + '        支持走廊模式，增加纵向狭长环境下监控区域\n' + '        支持多种智能报警\n' + '        支持Smart IR，防止夜间红外过曝\n' + '        高效红外灯,使用寿命长,照射距离40-50米\n' + '        ICR红外滤片式自动切换,实现真正的日夜监控\n' + '        支持PoE供电功能（选配）\n' + '        支持GB28181接入,支持Onvif接入\n' + '        支持Email、NTP服务\n' + '        支持HTTPS加密传输'
        //     },
        //     {
        //       id: '3243',
        //       model: 'YK-4200',
        //       name: '高清人脸识别终端',
        //       image: require('../../assets/img/hardware/yk4200.png'),
        //       detail: '最高分辨率可达2M(1920X1080@30fps)\n' + '        采用三维造型，工业级设计，俯仰角度、左右旋转可调\n' + '        一体机完成人脸抓拍、比对功能\n' + '        支持活体检测，有效防止照片、视频等欺骗\n' + '        人脸识别距离范围大\n' + '        采用多任务级联卷积神经网络的人脸检测技术\n' + '        采用深度学习算法，人脸库可达10000个\n' + '        导入人脸模板灵活，支持单张、批量图片文件导入和实时抓拍导入\n' + '        提供登录后查询、设置一体机参数，查看实时监控和人脸比对画面\n' + '        支持普通人员、白名单人员、黑名单人员等人脸类型\n' + '        在断网模式下可以单机运行\n' + '        提供485、I/O输入输出、韦根等外设接口'
        //     },
        //     {
        //       id: '3244',
        //       model: 'YK-4300',
        //       name: '16路5MP全实时网络硬盘录像机',
        //       image: require('../../assets/img/hardware/yk4300.png'),
        //       detail: '最大16路全实时500MP视频接入, 1U机箱NVR\n' + '        H.265/H.264双码流解码，嵌入式Linux操作系统\n' + '        支持同步录像、远程监看、备份\n' + '        HDMI输出，支持 1080P高清预览\n' + '        支持预览图像与回放图像12倍电子放大\n' + '        标准ONVIF、RTSP、GB28181协议\n' + '        报警抓拍、报警邮件发送功能\n' + '        支持DDNS、EMAIL、UPNP、NTP、P2P等功能\n' + '        支持WEB、手机监看、客户端、CMS监控\n' + '        支持外部报警、\n' + '        支持我司SMART IPC 目标计数、物品检测、区域检测、虚拟警戒线、\n' + '        支持磁盘分组配额、和磁盘盘组两种存储模式，可对不同的通道分配不同的录像保存容量或周期\n' + '        支持IPC集中管理，包括IPC参数配置、信息导入导出、信息实时获取和升级等功能\n' + '        支持通道分组，预览轮巡\n' + '        支持网络检测（网络流量监控、网络抓包、网络通畅）功能\n' + '        支持最大8路子码流录像同步回放和多路同步倒放\n' + '        支持即时回放功能\n' + '        全新的UI操作界面，支持一键开启录像功能\n' + '        支持双密码鉴权功能'
        //     }
        //   ]
        // }
      ],
      data: '',
      detail: '',
      selMenu: 0,
      dictPage: {'321': 0, '322': 1, '323': 2, '324': 3},
      dictModel: {'YK-8100': 0, 'YK-8210': 1, 'YK-8220': 2, 'YK-8300': 3, 'YK-8400': 4, 'YK-8500': 5, 'YK-8600': 6, 'YK-9100': 0,
        'YK-9200': 1, 'YK-9300': 2, 'YK-9400': 3, 'YK-9600': 4, 'YK-6110': 0, 'YK-6120': 1, 'YK-6210': 2, 'YK-6220': 3, 'YK-6230': 4, 'YK-6300': 5, 'YK-4110': 0,
        'YK-4120': 1, 'YK-4200': 2, 'YK-4300': 3}
    }
  },
  created() {
    document.documentElement.scrollTop = 0
    if (this.$route.query.page) {
      let sel = this.dictPage[this.$route.query.page]
      this.selMenu = sel
      this.data = this.dataList[sel].data
    } else {
      this.$router.push({query: {page: '321'}})
    }
  },
  watch: {
    $route: {
      handler() {
        console.log(this.$route.query)
        let page = this.$route.query.page
        let model = this.$route.query.model
        if (page && model) {
          this.clickHardwareExternal(page, model)
        } else if (page) {
          this.clickMenuExternal(page)
        }
      },
      deep: true
    }
  },
  methods: {
    clickMenu(i) {
      this.isDetail = false
      if (this.selMenu !== i || this.$route.query.model) {
        this.$router.push({path: this.$route.path, query: {page: this.dataList[i].id}})
      }
    },
    clickMenuExternal(page) {
      let sel = this.dictPage[page]
      this.selMenu = sel
      this.isDetail = false
      this.data = this.dataList[sel].data
    },
    clickHardware(data) {
      // document.documentElement.scrollTop = 660
      let params = JSON.parse(JSON.stringify(this.$route.query))
      this.$set(params, 'model', data.model)
      this.$router.push({query: params})
    },
    clickHardwareExternal(page, model) {
      let selPage = this.dictPage[page]
      let selModel = this.dictModel[model]
      this.isDetail = true
      this.detail = this.dataList[selPage].data[selModel]
    }
  }
}
</script>

<style scoped>
  .menu-class {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #efefef;
    color: #000000;
    cursor: pointer;
  }
  .menu-class-hover {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #00bf86;
    color: #ffffff;
    cursor: pointer;
  }
  .menu-class:hover {
    background-color: #00bf86;
    color: #ffffff;
  }
  .model-class {
    height: 40px;
    line-height: 40px;
    color: #000000;
    font-size: 16px;
    cursor: pointer;
  }
  .model-class:hover {
    color: #00bf86;
  }
  .model-class-ext {
    height: 40px;
    line-height: 40px;
    color: #000000;
    font-size: 16px;
  }
  .text-class {
    height: 30px;
    line-height: 30px;
    color: #000000;
    font-size: 14px;
  }
  .img-class {
    width: 70%;
    height: 100%;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Hardware.vue